import { cn } from "../cn";
import logoUrl from "../assets/orkestor-logo.png";

export interface LogoProps {
  className?: string;
  alt?: string;
}

/** Official Orkestor wordmark — the ring "O" brand mark, yellow variant for the
    dark UI (from E_Design/10_Brand/logos/logo-yellow.png). Height is driven by
    `className` (defaults to h-7, width auto to keep the aspect ratio). */
export function Logo({ className, alt = "Orkestor" }: LogoProps) {
  return <img src={logoUrl} alt={alt} className={cn("h-7 w-auto select-none", className)} />;
}
